// Společné prvky obrazovek Nastavení (hlavička, sekce, přepínač, záložky,
// zabalený formulář „Přidat …“) a skupiny otázek. Samostatně, aby se
// obrazovky Nastavení mohly načítat až při otevření (main-render.js LAZY_VIEWS).
import { ICONS, esc, state } from './state.js';
import { render } from '../main-render.js';

// Společná hlavička podstránek Nastavení: Zpět, nadpis, popis na jeden řádek.
// backOnclick (volitelné) = vlastní akce tlačítka Zpět, např. zrušení
// rozpracované úpravy místo odchodu ze stránky.
function settingsHeadHtml(title, desc, backView, backOnclick, actionHtml){
  return '<div class="view-head"><button class="btn btn-sm btn-ghost" style="margin-bottom:10px" onclick="'+(backOnclick||('App.goBack(\''+(backView||'settings')+'\')'))+'">← Zpět</button>' +
    (actionHtml ? '<div class="row-between" style="align-items:center;gap:10px"><h2>'+esc(title)+'</h2>'+actionHtml+'</div>' : '<h2>'+esc(title)+'</h2>') +
    (desc?'<p>'+esc(desc)+'</p>':'')+'</div>';
}
function settingsSectionHtml(label){ return '<div class="set-section">'+esc(label)+'</div>'; }
// Řádek s přepínačem. Přepíná se jen klepnutím na samotný přepínač, ne na
// popisek (rozhodnutí uživatele) — proto řádek není <label>.
function settingsSwitchRowHtml(id, title, desc, checked, onchange){
  return '<div class="set-row"><span class="set-row-text"><span class="set-row-title">'+esc(title)+'</span>' +
    (desc?'<span class="set-row-desc">'+esc(desc)+'</span>':'')+'</span>' +
    '<span class="switch"><input type="checkbox" id="'+id+'" aria-label="'+esc(title)+'" '+(checked?'checked':'')+(onchange?' onchange="'+onchange+'"':'')+'/><span></span></span></div>';
}
// Formulář "přidat …" je zabalený pod tlačítkem, ať seznam pod ním je hned
// vidět; rozbalený je vždy jen jeden (state.addFormOpen, při změně
// obrazovky se zavře).
function addFormHtml(key, label, bodyHtml){
  if(state.addFormOpen!==key){
    return '<button class="btn btn-primary btn-block" onclick="App.openAddForm(\''+key+'\')">'+ICONS.plus+' '+esc(label)+'</button>';
  }
  return '<div class="card" id="addForm_'+key+'">'+bodyHtml +
    '<button class="btn btn-ghost btn-block" style="margin-top:8px" onclick="App.openAddForm(null)">Zrušit</button></div>';
}
App.openAddForm = function(key){
  state.addFormOpen = key || null;
  render();
  if(key){
    var el = document.querySelector('#addForm_'+key+' input, #addForm_'+key+' select');
    if(el) try{ el.focus(); }catch(e){}
  }
};
function closeAddForm(){ state.addFormOpen = null; render(); }
function settingsTabsHtml(tabs, current, onclickFn){
  return '<div class="pill-select" style="margin-bottom:14px">' + tabs.map(function(t){
    return '<button class="'+(current===t[0]?'on':'')+'" onclick="'+onclickFn+'(\''+t[0]+'\')">'+esc(t[1])+(t[2]||'')+'</button>';
  }).join('') + '</div>';
}
App.toggleGroup = function(gid){
  if(state.collapsedGroups.has(gid)) state.collapsedGroups.delete(gid); else state.collapsedGroups.add(gid);
  render();
};

export { addFormHtml, closeAddForm, settingsHeadHtml, settingsSectionHtml, settingsSwitchRowHtml, settingsTabsHtml };
